module.exports = __webpack_public_path__ + "static/media/googleplay.3cb137f3.svg";